import React from 'react';

import { Button } from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import PropTypes from 'prop-types';

const Buttons = ({
    cancelText = i18next.t('Cancel').toUpperCase(),
    confirmText = i18next.t('Accept').toUpperCase(),
    disabledBackButton,
    disabledConfirmButton,
    handleClickCancel,
    handleClickSuccess,
    type,
}) => {
    if (type === 'confirm')
        return (
            <>
                <Button
                    disabled={disabledBackButton}
                    onClick={handleClickCancel}
                    type="button"
                    variant="text"
                >
                    {cancelText}
                </Button>{' '}
                <Button
                    disabled={disabledConfirmButton}
                    onClick={handleClickSuccess}
                    type="button"
                    variant="text"
                >
                    {confirmText}
                </Button>
            </>
        );

    if (type === 'only_confirm')
        return (
            <Button type="button" onClick={handleClickSuccess}>
                {confirmText}
            </Button>
        );

    return (
        <Button type="button" onClick={handleClickCancel}>
            {confirmText}
        </Button>
    );
};

Buttons.propTypes = {
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    disabledBackButton: PropTypes.bool,
    disabledConfirmButton: PropTypes.bool,
    handleClickCancel: PropTypes.func,
    handleClickSuccess: PropTypes.func,
    type: PropTypes.string,
};

export default Buttons;
